export default {"src":"/_next/static/media/icon_play_brackets_v2.c1968157.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};